export const PROMO_BANNER_STYLES = {
  root: "w-full",
  card: "relative flex flex-col md:flex-row md:h-[400px] overflow-hidden rounded-[24px] border border-ticketon-sky-blue bg-gradient-to-b from-white to-[#9AD2FE] shadow-component p-4 md:p-0",
  background: "hidden",
  textSide:
    "relative z-20 flex w-full flex-col justify-center gap-10 bg-transparent p-0 md:w-[390px] md:shrink-0 md:p-12 order-3 md:order-1 my-6 md:my-0",
  logo: "h-auto w-[200px] max-w-full mb-4 md:mb-0",
  logoWrapper: "flex justify-center md:justify-start order-1 md:order-none mb-4 md:mb-0 mt-4 md:mt-0",
  eyebrow: "text-[20px] font-bold text-orange-dark",
  title: "text-[30px] font-bold leading-[1.1] tracking-[0] text-ticketon-gray-600 hidden md:block",
  description: "text-[18px] font-normal leading-[1.3] tracking-[0] text-ticketon-gray-600 hidden md:block",
  cta: "inline-flex h-[48px] w-full md:w-[225px] items-center justify-center gap-[10px] rounded-[9px] bg-ticketon-blue px-[12px] py-[10px] text-[18px] font-semibold leading-[1] tracking-[0] text-white transition-colors hover:bg-ticketon-lighter-blue-hover",
  image: "h-full w-full object-cover",
  imageWrapper: "relative h-[400px] rounded-[32px] overflow-hidden order-2 mb-4 -mx-4 w-[calc(100%+2rem)] md:flex-1 md:h-full md:rounded-none md:rounded-l-[300px] md:mb-0 md:mx-0 md:w-auto md:order-2",
  overlay:
    "absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-gradient-to-r from-transparent via-black/25 to-black/35 text-center text-white",
  discountLabel: "text-[28px] md:text-[40px] font-semibold uppercase leading-[1]",
  discountValue:
    "flex items-start justify-center gap-2 leading-none",
  discountNumber: "text-[120px] md:text-[160px] font-bold leading-[1]",
  discountMeta: "flex flex-col items-start justify-start pt-1",
  discountPercent: "text-[80px] md:text-[109px] font-bold leading-[1]",
  discountSuffix: "text-[32px] md:text-[42px] font-normal uppercase leading-[1]",
  offerTitle: "text-[24px] md:text-[40px] font-semibold leading-[1.1]",
} as const;
